import { ReactNode } from 'react';
import { Drawer as AntDrawer } from 'antd';
import clsx from 'clsx';
import { useTranslation } from 'react-i18next';
import IconButton from '@/components/icon-button/icon-button';
import CloseIcon from '@/assets/icons/x-close.svg?react';
import styles from './drawer.module.scss';

interface DrawerProps {
  open: boolean;
  onClose: () => void;
  title: string;
  meta?: ReactNode;
  children: ReactNode;
  className?: string;
}

export default function Drawer({ open, onClose, title, meta, children, className }: DrawerProps) {
  const { t } = useTranslation('common');

  return (
    <AntDrawer
      className={clsx(styles.drawer, className)}
      // Antd's own close button is suppressed: the mockup's is the bordered
      // 32px square from the icon-button primitive.
      closable={false}
      maskClosable
      onClose={onClose}
      open={open}
      placement="right"
      // Inline, not classes: antd scopes both rules as `.ant-drawer .ant-drawer-*`
      // at specificity (0,2,0), which beats any single class regardless of
      // injection order. The wrapper's 100vw cap and 0.3s motion are its own.
      styles={{
        mask: { backgroundColor: 'rgba(18, 19, 28, 0.35)' },
        wrapper: { maxWidth: '94vw', transition: 'transform 0.28s ease' },
      }}
      title={
        <>
          <div className={styles.head}>
            <h3 className={styles.title}>{title}</h3>
            <IconButton label={t('actions.close')} onClick={onClose} shape="square-lg">
              <CloseIcon aria-hidden="true" />
            </IconButton>
          </div>
          {meta && <div className={styles.meta}>{meta}</div>}
        </>
      }
      width={580}
    >
      {children}
    </AntDrawer>
  );
}
